// extracted by mini-css-extract-plugin
export default {"container":"dynamicPageLoader__container__cU5Wx","component":"dynamicPageLoader__component__qiCKE","active":"dynamicPageLoader__active__P0Vqe"};